export enum PersonalizeModeEnum {
  STANDART = 'Standard',
}

export enum PersonalizeOperatorEnum {
  IN = 'IN',
  NI = 'NI',
}

export enum PersonalizeInputTypeEnum {
  MULTI_OPTION = 'MultiOption',
}

export enum PersonalizeInputDataTypeEnum {
  ARRAY_OF_INT = 'ArrayInt',
}

export enum PersonalizeVariantNameEnum {
  DEFAULT = 'Default',
}

export enum PersonalizedEnum {
  NON_PERSONALIZED = 'NON_PERSONALIZED',
  PERSONALIZED = 'PERSONALIZED',
}

export type PersonalizeOptionSourceType =
  | 2 /** BE provide data directly */
  | 3 /** source data from other API */

export enum PersonalizeRuleActionEnum {
  IGNORED = 0 /** perso rule will be ignore */,
  USED = 1 /** perso rule will be used */,
}

export enum PersonalizeIdentifierTypeEnum {
  HomeBanner = 1,
  Catalog = 2,
  DynamicChannel = 3,
  InfiniteTabbing = 5,
}

export type PersonalizeOptionType = {
  option_key: number
  option_key_str: string
  option_value: string
}

export type PersonalizeAttributeType = {
  id: number
  name: string
  input_type: PersonalizeInputTypeEnum
  input_data_type: PersonalizeInputDataTypeEnum
  option_source_type: PersonalizeOptionSourceType
  operator_list: PersonalizeOperatorEnum[]
  option_list: PersonalizeOptionType[]
}

export type PersonalizeType = {
  mode: PersonalizeModeEnum
  is_exclusive: boolean
  is_open_based: boolean
  variants: PersonalizeVariantType[]
}

export type PersonalizeVariantType = {
  name: PersonalizeVariantNameEnum
  rules: {
    attribute: string
    symbol: PersonalizeOperatorEnum
    value: Array<PersonalizeOptionType['option_key']>
  }
}

export type PersonalizeInitialStateType = {
  personalizationAttributes: PersonalizeAttributeType[]
  personalizationCurrent: Nullable<PersonalizeDetailType>
  personalizationForm: PersonalizeFormType
}

export type PersonalizeFormType = Omit<PersonalizeType, 'variants'> & {
  isActive: boolean
  attributes: PersonalizeAttributeFormType[]
}

export type PersonalizeAttributeFormType = {
  key: string
  attribute: Nullable<PersonalizeAttributeType>
  selectedOperator: PersonalizeOperatorEnum
  selectedOption: Nullable<PersonalizeAttributeType['option_list']>
}

export type PersonalizeDetailType = {
  identifier_type: PersonalizeIdentifierTypeEnum
  id: number
  identifier: number
  rules_string: string
}

export type PersonalizationRequestPayloadType = {
  perso_rules: string
  perso_rules_ation: PersonalizeRuleActionEnum
  perso_rules_action: PersonalizeRuleActionEnum
}

// reducers
export type SetPersonalizationFormPayloadActionType = {
  field: keyof PersonalizeFormType
  value: PersonalizeFormType[keyof PersonalizeFormType]
}

export type SetPersonalizationAttributeFormPayloadActionType = {
  index: number
  field: keyof PersonalizeAttributeFormType
  value: PersonalizeAttributeFormType[keyof PersonalizeAttributeFormType]
}
